import React from 'react';

import { Callout } from '../../../../components';

/**
 * What the section and the mailbox page say when this environment has NO mail service configured
 * (`MAILBOX_SOURCE === 'unavailable'`, see `config/mailboxSource.ts`). A fact about the environment,
 * not a failure: no retry (nothing changes until someone configures it), no fixtures, no Create. The
 * service being configured but not answering is a different screen, worded apart (see
 * `LoadFailedNotice`), so nobody retries this one or gives up on that one.
 */
export const MailboxUnavailableNotice = (): React.ReactElement => (
  <div data-testid="mailbox-unavailable-notice">
    <Callout tone="info" text="The mailbox service is not available in this environment." />
  </div>
);

export default MailboxUnavailableNotice;
